import { render } from "./ProfileChoiceCard.vue?vue&type=template&id=b225dfb8"
import script from "./ProfileChoiceCard.vue?vue&type=script&lang=js"
export * from "./ProfileChoiceCard.vue?vue&type=script&lang=js"

import "./ProfileChoiceCard.vue?vue&type=style&index=0&id=b225dfb8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__